import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { USER_INFO_LOCAL_STORAGE_KEY } from '@shared/utils/constant';

export const authGuard: CanActivateFn = (route, state) => {
  const router = inject(Router);
  const userInfo = localStorage.getItem(USER_INFO_LOCAL_STORAGE_KEY);
  if (!userInfo) {
    router.navigate(['/']);
    return false;
  }
  return true;
};
